/** @format */

import { TStore } from "../declarations/store";

export const selectorReduxStore = (store: TStore): TStore => store;
